// extracted by mini-css-extract-plugin
export var darkModeIconFill = "styles-module--darkModeIconFill--3nnw5";
export var lightModeIconFill = "styles-module--lightModeIconFill--2CniU";